var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMotion(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 58,
    viewBox: "0 0 54 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39 1H13C10.2386 1 8 3.23858 8 6V52C8 54.7614 10.2386 57 13 57H39C41.7614 57 44 54.7614 44 52V6C44 3.23858 41.7614 1 39 1Z",
    stroke: "url(#paint0_linear_2452_76)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26 53C27.1046 53 28 52.1046 28 51C28 49.8954 27.1046 49 26 49C24.8954 49 24 49.8954 24 51C24 52.1046 24.8954 53 26 53Z",
    fill: "#986DFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6546 12.3401H2C0.89543 12.3401 0 13.2355 0 14.3401V25.0001C0 26.1047 0.89543 27.0001 2 27.0001H24.6546C25.7592 27.0001 26.6546 26.1047 26.6546 25.0001V14.3401C26.6546 13.2355 25.7592 12.3401 24.6546 12.3401Z",
    fill: "url(#paint1_linear_2452_76)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.66406 17.1885H21.6564",
    stroke: "#110E1B",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.66406 21.7842H15.3259",
    stroke: "#110E1B",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M24 5H29",
    stroke: "url(#paint2_linear_2452_76)",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M46 32H33C31.8954 32 31 32.8954 31 34V41C31 42.1046 31.8954 43 33 43H46C47.1046 43 48 42.1046 48 41V34C48 32.8954 47.1046 32 46 32Z",
    fill: "#110E1B",
    stroke: "#986DFF",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2452_76",
    x1: 3.23529,
    y1: -13.4667,
    x2: 24.6708,
    y2: 63.0313,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2452_76",
    x1: 13.7869,
    y1: 15.9706,
    x2: -1.75438,
    y2: 18.7034,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#986DFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#986DFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2452_76",
    x1: "-nan",
    y1: "-nan",
    x2: "-nan",
    y2: "-nan",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMotion);
export default __webpack_public_path__ + "static/media/motion.2509dda3becf36ecc418bb6f12d10cb3.svg";
export { ForwardRef as ReactComponent };